import React from "react";

import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";

import { Label } from "@busbud/horizon";

import { getLocalizedPrice } from "@app/components/localized-price";
import { useAppContext } from "@app/helpers/hooks";
import { getMaxPriceFilter } from "@app/modules/results/selectors/state-accessors";
import { getTripsMaxMinPrice } from "@app/modules/results/selectors/trips/get-trips-max-min-price";
import { setMaxPrice } from "@app/modules/results/state/filters";

import { useStyles } from "./price-range.styles";

export const PriceRange = () => {
  const dispatch = useDispatch();
  const context = useAppContext();
  const { translator } = useAppContext();

  const max_min_price_in_cents = useSelector(getTripsMaxMinPrice);
  const state_filter_price_values = useSelector(getMaxPriceFilter);
  const minimum = max_min_price_in_cents.min;
  const maximum = max_min_price_in_cents.max;

  const price = state_filter_price_values || maximum;
  const price_interval = maximum - minimum;
  const backgroundSize =
    price_interval > 0 ? ((price - minimum) * 100) / price_interval : 100;
  const { classes } = useStyles({ backgroundSize });

  const display_price = getLocalizedPrice(
    {
      ceiled: true,
      without_cents: true,
      price_in_cents: price
    },
    context
  );

  const handleRangeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    dispatch(
      setMaxPrice(event.target.value ? parseFloat(event.target.value) : 0)
    );
  };

  const label = translator.t("!results.filters.price.value", {
    price: display_price
  });

  const disabled = price_interval === 0;

  return (
    <div
      className={clsx(classes.inputRange, "flex flex-col gap-075", {
        "opacity-50": disabled
      })}
    >
      <Label
        size="md"
        fontWeight="extraBold"
        className="text-color-tertiary"
        as="p"
      >
        {label}
      </Label>
      <input
        type="range"
        min={minimum}
        max={maximum}
        value={price}
        onChange={handleRangeChange}
        disabled={disabled}
      />
    </div>
  );
};
